/* Variantenbild: Hauptbild wechselt zum Bild der gewählten Variante.
   Beim Laden wird das erste Produktbild gezeigt; erst eine vom Standard abweichende Auswahl wechselt das Bild. */
(function(){
var img=document.getElementById('main-img');if(!img)return;
var gal=document.getElementById('gal');
var firstSrc=null;
if(gal){var di=gal.getAttribute('data-images');if(di){firstSrc=di.split('|')[0]||null}}
var defaultSrc=firstSrc||img.getAttribute('src'),defaultAlt=img.getAttribute('alt');
if(firstSrc&&img.getAttribute('src')!==firstSrc){img.src=firstSrc;}
function vars(){return window.TP_VARIANTS||[]}
var initial=null;
function readSel(){
 var o={};
 [].slice.call(document.querySelectorAll('.opt-sel')).forEach(function(s){o[s.getAttribute('data-pos')]=s.value});
 if(Object.keys(o).length===0){
  [].slice.call(document.querySelectorAll('.opt-vals[data-pos]')).forEach(function(w){
   var b=w.querySelector('.opt-btn.sel');if(b)o[w.getAttribute('data-pos')]=b.getAttribute('data-val');
  });
 }
 return o;
}
function same(a,b){return a&&b&&a['1']===b['1']&&a['2']===b['2']&&a['3']===b['3']}
function current(o){
 var vs=vars();
 for(var i=0;i<vs.length;i++){var v=vs[i];
  if((!o['1']||v.option1===o['1'])&&(!o['2']||v.option2===o['2'])&&(!o['3']||v.option3===o['3']))return v;}
 return null;
}
function setSrc(src,alt){if(!src)return;if(src.indexOf('//')===0)src='https:'+src;if(img.getAttribute('src')!==src){img.src=src;if(alt)img.alt=alt}}
function upd(){
 if(initial===null)return;
 var o=readSel();
 if(same(o,initial)){setSrc(defaultSrc,defaultAlt||'');return}
 var v=current(o);
 if(v&&v.featured_image&&v.featured_image.src)setSrc(v.featured_image.src,v.featured_image.alt||'');
}
function init(){if(initial===null){initial=readSel()}}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(init,80)})}else{setTimeout(init,80)}
document.addEventListener('change',function(e){if(e.target&&e.target.classList&&e.target.classList.contains('opt-sel'))setTimeout(upd,30)});
document.addEventListener('click',function(e){if(e.target.closest('.opt-vals .opt-btn'))setTimeout(upd,60)});
document.addEventListener('tp:update',function(){setTimeout(upd,30)});
})();